<template>
  <div>
    <div>
      <!-- Home page content -->
      <main role="main">
        <div class="text-center mt-4">
          <div class="container m-auto">
            <h1 class="page-heading">{{ $t('Home.BannerTitle') }}</h1>
            <div class="page-subheader">
              <p class="page-subheader" v-html="$t('Home.BannerDesc')"></p>

              <p>
                <router-link to="/Upload" class="btn btn-link btn-lg">
                  {{ $t('Home.GetStartedBtn') }}</router-link
                >
              </p>
              <!-- <small>{{ $t('Home.bannersmalltxt') }}</small
              > -->
              <br />
            </div>
          </div>
        </div>
        <div class="btmImgsection">
          <div class="container text-center">
            <img :src="$t('Home.btmProductImg')" alt="Snap" class="img-fluid" />
          </div>
        </div>
        <div class="how-to-blk py-5 px-4">
          <div class="container">
            <h2
              class="text-center mb-5 fw-light"
              v-html="$t('Home.HowToParticipateTitle')"
            ></h2>
            <div class="row text-center d-flex justify-content-center">
              <div class="col-md-6 col-lg-3 home-card-bg">
                <div class="home-card">
                  <img
                    :src="$t('Home.ShopImg')"
                    alt="Shop"
                    class="img-fluid mb-3"
                  />
                  <!-- <h4>  {{ $t('Home.ShopTitle') }}</h4> -->
                  <p>
                    <small v-html="$t('Home.ShopDetail')"></small>
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-lg-3 home-card-bg">
                <div class="home-card">
                  <img
                    :src="$t('Home.SnapImg')"
                    alt="Snap"
                    class="img-fluid mb-3"
                  />
                  <!-- <h4>  {{ $t('Home.SnapTitle') }}</h4> -->
                  <p>
                    <small v-html="$t('Home.SnapDetail')"></small>
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-lg-3 home-card-bg">
                <div class="home-card">
                  <img
                    :src="$t('Home.SendImg')"
                    alt="Send"
                    class="img-fluid mb-3"
                  />
                  <!-- <h4>  {{ $t('Home.SendTitle') }}</h4> -->
                  <p>
                    <small v-html="$t('Home.SendDetail')"></small>
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-lg-3 home-card-bg">
                <div class="home-card">
                  <img
                    :src="$t('Home.RegisterImg')"
                    alt="Register"
                    class="img-fluid mb-3"
                  />
                  <!-- <h4>{{ $t('Home.RegisterTitle') }}</h4> -->
                  <p>
                    <small v-html="$t('Home.RegisterDetail')"></small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ready-to-blk pt-5 pb-5">
          <div class="container">
            <div class="text-center">
              <h2 class="">{{ $t('Home.ReadytoSubmitTitle') }}</h2>
              <p class="mt-3" v-html="$t('Home.ReadytoSubmitDesc')"></p>
              <p class="mt-4 mb-4">
                <router-link to="/Upload" class="btn btn-link btn-lg">
                  {{ $t('Home.GetStartedBtn') }}</router-link
                >
              </p>
              <p class="mb-1">
                <span v-html="$t('Home.ParticipatingProductLink')"></span>
              </p>
              <p class="mb-0">
                <span>
                  <router-link to="/Support?havingTrouble" class="anc-link">{{
                    $t('Home.HavingTroubleLink')
                  }}</router-link>
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="hm-btm-blk text-center mt-5 pt-3 mb-5">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-5">
                <h2 class="h1 mb-4" v-html="$t('Home.ProductTitle')"></h2>
                <p class="mb-4 pb-2" v-html="$t('Home.ProductDesc')"></p>
              </div>
              <div class="col-md-7">
                <img
                  :src="$t('Home.HmRtImg')"
                  alt="product"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="hm-btm-blk text-center mt-5 pt-3 mb-5">
          <div class="container">
           
            <div class="row align-items-center">
              <div class="col-md-5">
                <h2 class="h1 mb-4" v-html="$t('Home.HmBtmTitle')"></h2>
                <p class="mb-4 pb-2" v-html="$t('Home.HmBtmDesc')"></p>
              </div>
              <div class="col-md-7">
                <img
                  :src="$t('Home.ProductImg')"
                  alt="product"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div> -->
        <div class="abbv-txt mb-5">
          <div class="container">
            <hr />
            <div v-html="$t('Footer.legalrules')"></div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
@media screen and (max-width: 575px) {
}
</style>

<style scoped>
/* .home-card-bg {
  position: relative;
}
.home-card {
  box-shadow: 0 15px 25px rgba(129, 124, 124, 0.2);
  height: 380px;
  border-radius: 19px;
  backdrop-filter: blur(14px);
  background-color: rgb(255 255 255 / 20%);
  padding: 15px;
  text-align: left;
  line-height: 23px;
  font-size: 1.2rem;
}
.home-card-bg:before {
  content: '';
  position: absolute;
  height: 70px;
  width: 70px;
  top: -9px;
  left: 5px;
  background-color: #bf233a;
  border-radius: 18px;
}
.home-card img {
  height: 70px;
} */
/* .readytosubmit {
  background: #bf233a2b;
  border: 1px solid #bf233a;
  border-radius: 10px;
  padding: 20px 30px;
} */
@media screen and (max-width: 575px) {
  .home-card {
    height: auto;
    margin-bottom: 40px;
  }
}
</style>
